
import { Vue, Component } from 'vue-property-decorator';
import lazyInject from '@/di';
import ShopService from '@/services/shop.service';
import UTILService from '@/services/utils.service';

@Component
export default class ChangeLabelModal extends Vue {
  visible = false;

  labelCol = { span: 8 };

  wrapperCol = { span: 10 };

  @lazyInject(ShopService)
  shopService!: ShopService;

  @lazyInject(UTILService)
  private utilService!: UTILService;

  form: any = {
    shopId: '',
    labelId: '',
  };

  async init(item: any) {
    // console.log(item);
    this.visible = true;
    const { shopId, labelId } = item;
    this.form = {
      shopId,
      labelId,
    };
  }

  handleCancel() {
    this.visible = false;
  }

  async handleOk() {
    const res = await this.shopService.postUpdateLabel(this.form);
    if (res) {
      this.$message.success('操作成功');
      this.visible = false;
      this.$emit('refresh');
    }
  }
}
